import {
  getTableauToken,
} from '../../../apis/premier-plus-api';
import {handleApiError} from '../../../shared/actions';

export const fetchTableauToken = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'CLEAR_TABLEAU_TOKEN',
  });
  dispatch({
    type: 'FETCH_TABLEAU_TOKEN_STARTED',
  });
  var response = null;
  const emailAddress = getState().auth.emailAddress;
  try {
    response = await getTableauToken(emailAddress);
  }
  catch (errorCode) {
    dispatch({
      type: 'FETCH_TABLEAU_TOKEN_FAILED',
    });
    dispatch(handleApiError(errorCode));
    return;
  }
  dispatch({
    type: 'FETCHED_TABLEAU_TOKEN',
    token: response.body,
  });
});

export const fetchTableauTokenForSelectedReport = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'CLEAR_TABLEAU_TOKEN_FOR_SELECTED_REPORT',
  });
  dispatch({
    type: 'FETCH_TABLEAU_TOKEN_FOR_SELECTED_REPORT_STARTED',
  });
  var response = null;
  const emailAddress = getState().auth.emailAddress;
  try {
    response = await getTableauToken(emailAddress);
  }
  catch (errorCode) {
    dispatch({
      type: 'FETCH_TABLEAU_TOKEN_FOR_SELECTED_REPORT_FAILED',
    });
    dispatch(handleApiError(errorCode));
    return;
  }
  dispatch({
    type: 'FETCHED_TABLEAU_FOR_SELECTED_REPORT_TOKEN',
    token: response.body,
  });
});

export const userSelectedReport = (reportUrl, reportTitle) => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_SELECTED_REPORT',
    reportUrl: reportUrl,
    reportTitle: reportTitle,
  });
  await dispatch(fetchTableauTokenForSelectedReport());
  dispatch({
    type: 'SHOW_REPORT_MODAL',
  });
});

export const hideReportModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_REPORT_MODAL',
  });
});
